import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/cuidemoslosrios.png";
import Imagen2 from "../../../images/modulo13/pensamiento.png";
import Imagen3 from "../../../images/modulo13/cantera.png";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad4.mp3";

const Actividad6 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "conservación" },
    ans2: { value: "", valid: "", correctValue: "ecología" },
    ans3: { value: "", valid: "", correctValue: "explotación" },
  });
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[4];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[5].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[5].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[3].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[3].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>Completa los siguientes textos con palabras del recuadro:</li>
      </ul>

      <Card>
        <div className="d-flex justify-content-around">
          <div>conservación</div>
          <div>explotación</div>
          <div>ecología</div>
        </div>
      </Card>
      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <p className="fs-5 p-3 p-md-0">
              Johnny Fuller estudia ingeniería en la universidad. Mónica Quevedo
              lo ha invitado a hablar con sus estudiantes. Johnny les explica la
              importancia de no echar basura al río y mantener su cauce limpio.
              “Esto es muy importante para la seguridad de los vecinos que viven
              cerca del río y para la{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm w-200 d-inline-block " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />{" "}
              del agua”, les dice.
            </p>
          </div>
          <div className="col-md-6 col-12 text-center">
            <img src={Imagen1} alt="Peruanos" className="img-fluid" />
          </div>
        </div>
      </Card>

      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <p className="fs-5 p-3 p-md-0">
              Syndi Sangama está preocupada por el futuro de Loreto. Le gustaría
              estudiar ingeniería medioambiental. Lo que más le interesa conocer
              es la relación de las personas, animales y plantas con el medio en
              el que viven, es decir, la{" "}
              <input
                type="text"
                className={
                  "form-control form-control-sm w-200 d-inline-block " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
              .
            </p>
          </div>
          <div className="col-md-6 col-12 text-center">
            <img src={Imagen2} alt="Peruanos" className="img-fluid" />
          </div>
        </div>
      </Card>

      <Card>
        <div className="row align-items-center">
          <div className="col-md-6 col-12">
            <p className="fs-5 p-3 p-md-0">
              La mamá de Brayan López le ha contado que van a reabrir la cantera
              de yeso que queda cerca de su pueblo en Junín. Se saca provecho de
              este recurso natural para diversos usos en la construcción. La
              <input
                type="text"
                className={
                  "form-control form-control-sm w-200 d-inline-block " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />{" "}
              de la cantera dará trabajo a muchas personas.
            </p>
          </div>
          <div className="col-md-6 col-12 text-center">
            <img src={Imagen3} alt="Peruanos" className="img-fluid" />
          </div>
        </div>
      </Card>

      <div className="row my-4">
        <div className="col-12">
          <button
            className={`btn float-end btn-${modulo13.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Explique  que trabajarán con vocabulario y
            conceptos nuevos vinculados al acceso y manejo de recursos. Para
            ello, realizarán actividades en las que usarán las pistas que nos da
            el contexto para identificar el significado de las palabras.
          </li>
          <li>
            Lea la indicación: Completa los siguientes textos con palabras del
            recuadro: conservación, explotación, ecología. Pida que trabajen en silencio. No es necesario que sepan el
            significado de las palabras, pues lo podrán determinar a partir del
            contexto del párrafo. Déles un tiempo para trabajar. Pida que comparen sus respuestas con las de un compañero, 
            compañera o familiar. En caso de que sus respuestas no coincidan, deberán
            discutir sobre cuál es la mejor opción. Pida a un estudiante que lea
            en voz alta el primer texto. A partir del texto leído, pregunte:
            “¿Cuál es el significado de la palabra “conservación” en el texto?
            (Posible respuesta: En este caso, significa mantener o cuidar el
            agua)”.
          </li>
          <li>
            Pida a un estudiante que lea en voz alta el segundo texto. A partir
            del texto leído, pregunte: “¿Cuál es el significado de la palabra
            “ecología” en el texto? (Posible respuesta: Es la ciencia que
            estudia la relación entre los seres vivos y su medio)”.
          </li>
          <li>
            Pida a un estudiante que lea en voz alta el último texto. A partir
            del texto leído, pregunte: “¿Cuál es el significado de la palabra
            “explotación” en el texto? (Posible respuesta: Se denomina
            explotación al acto de sacar provecho de un producto natural)”.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
